import { useQuery } from "@apollo/client";
import { GET_BPM_ROLE_ASSIGNMENT_LIST } from "@/modules/admin-panel/features/bpm-roles/list";

export function useBpmRoles() {
  const { data, loading, previousData } = useQuery(
    GET_BPM_ROLE_ASSIGNMENT_LIST,
  );

  const records =
    data?.getHrRoleAssignmentList ??
    previousData?.getHrRoleAssignmentList ??
    [];

  return {
    records,
    loading,
  };
}
